import React, { useState } from 'react';
import { useLoads, useDeleteLoad, useVans,useDownloadLoadDetails } from './loads.hooks';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Paper, TableContainer, Typography, Pagination,
  CircularProgress, Box, TextField, Stack, Divider, Button,
  Select, MenuItem, InputLabel, FormControl, Tooltip,Link
} from '@mui/material';

import LoadDetails from './LoadDetailsPopup';
import { constants } from '../../constants';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
export default function ManageLoadsPage() {
  const dispatch = useDispatch();
  const deleteMutation = useDeleteLoad();
  const [filters, setFilters] = useState({
    datetime: '',
    vanid: '0',
  });
  const [tempFilters, setTempFilters] = useState(filters); // temporary inputs
  const [page, setPage] = useState(1);
  const [downloadLoadId,setDownloadLoadId] =useState(0);
  const perPage = constants.PERPAGE;
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { data: allvans = [], isLoading: isLoadingVans } = useVans();
  const { data: loadData, isLoading,isError,error } = useLoads(
    { filters, page, perPage }
  );

  if(isError)
  {
      dispatch(
        showAlert({
          severity: constants.ERROR,
          title: error?.response?.data?.message || 'Error fetching loads.',
        })
      );
    }

  const popupOpen = (id) => {
    setOpenPopup(true);
    setSelectedId(id);
  };

  const popupClose = () => {
    setOpenPopup(false);
    setSelectedId(null);
  };



  const handleInputChange = (e) => {
    setTempFilters({ ...tempFilters, [e.target.name]: e.target.value });
  };



  const handleDelete = (id) => {
    if (!window.confirm('Are you sure you want to delete this load?')) return;
  
    deleteMutation.mutate(id, {
      onSuccess: () => {
        dispatch(
          showAlert({
            severity: constants.SUCCESS,
            title: 'Load deleted successfully.',
          })
        );
      },
      onError: () => {
        dispatch(
          showAlert({
            severity: constants.ERROR,
          title: error?.message || 'Error fetching loads.',
          })
        );
      },
    });
  };
  const handleDownloadLoad=(id)=>{
    setDownloadLoadId(id)
  }


  const { data:downloadData, isLoading:downloadLoading,isSuccess:downloadIsSuccess,isError:downloadIsError,error:downloadError  } = useDownloadLoadDetails(downloadLoadId);

  React.useEffect(() => {
    if (downloadIsSuccess && downloadData) {
      const blob = new Blob([downloadData],  {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = 'load-details-'+downloadLoadId+'.xlsx'; 
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch(
        showAlert({
          severity: constants.SUCCESS,
          title: 'The load has been successfully downloaded.',
        })
    );
      setDownloadLoadId(null);
  }
  }, [downloadIsSuccess, downloadData,dispatch]);


  React.useEffect(() => {
    if (downloadIsError) {
      dispatch(
        showAlert({
          severity: constants.ERROR,
          title: downloadError?.message || 'Error fetching loads.',
        })
      );
    }
  }, [downloadIsError, downloadError, dispatch]);
  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Manage Loads
      </Typography>

      {/* Filter Section */}
      <Box sx={{ my: 2 }}>
        
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextField
            fullWidth
            name="datetime"
            type="date"
            label="Filter by load time"
             slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
            value={tempFilters.datetime}
            onChange={handleInputChange}
          />
<FormControl fullWidth>
  <InputLabel id="vanid-label">Filter by Van</InputLabel>
  <Select
    labelId="vanid-label"
            name="vanid"
              value={tempFilters.vanid}
    label="Filter by Van"
              onChange={handleInputChange}
  >
              <MenuItem key={0} value="0">All Vans</MenuItem>
    {Array.isArray(allvans) &&
  allvans.map((van) => (
    <MenuItem key={van.id} value={String(van.id)}>
      {van.name} 
    </MenuItem>
))}
  </Select>
</FormControl>
          <Button
            variant="contained"
            onClick={() => {
              setFilters({ ...tempFilters });
              setPage(1);
            }}
            sx={{ height: '56px' }} // match TextField height
          >
            Apply Filter
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setTempFilters({ datetime: '', vanid: '' });
              setFilters({ datetime: '', vanid: '' });
              setPage(1);
            }}
            sx={{ height: '56px' }}
          >
            Reset
          </Button>
        </Stack>
      </Box>

      <Divider sx={{ my: 2 }} />

      {(isLoading || isLoadingVans || downloadLoading) && (
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={10}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="rgba(255, 255, 255, 0.7)"
      >
        <CircularProgress />
      </Box>
    )}
      {/* Table Section */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Van</TableCell>
              <TableCell>Load Price</TableCell>
              <TableCell>Sale Price</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loadData?.data?.length > 0 ? (
  loadData.data.map((load) => (
              <TableRow key={load.id}>
                <TableCell>{load.id}</TableCell>
                <TableCell>{load.datetime?.split(' ')[0]}</TableCell>
                  <TableCell>{load.van?.name ?? 'N/A'}</TableCell>
                  <TableCell>€ {load.loadprice}</TableCell>
                  <TableCell>€ {load.saleprice}</TableCell>
                <TableCell>  
                    <Tooltip title="View Details">

                  <Button
                    size="small"
                    color="primary"
                    onClick={() => popupOpen(load.id)}
                        sx={{ minWidth: 0 }}
                  >
                        <VisibilityRoundedIcon />
            </Button>
                    </Tooltip>
                    <Tooltip title="Delete Load">
                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleDelete(load.id)}
                        sx={{ minWidth: 0 }}
                      >
                        <DeleteRoundedIcon />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Download Load">
                      <Button
                        size="small"
                        color="primary"
                        sx={{ minWidth: 0 }}
                        onClick={() => handleDownloadLoad(load.id)}
                      >
             <FileDownloadIcon />
                
                      </Button>
                    </Tooltip>
                </TableCell>
              </TableRow>
  ))
) : (
  <TableRow>
    <TableCell colSpan={6} align="center">
      No records found.
    </TableCell>
  </TableRow>
)}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {loadData?.data?.length > 0 && (
      <Box mt={3} display="flex" justifyContent="center">
        <Pagination
          count={loadData?.last_page || 1}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
      </Box>
)}

      {/* Load Details Popup */}
      {selectedId && (
        <LoadDetails loadid={selectedId} open={openPopup} onClose={popupClose}/>
      )}
    </Paper>
  );
}
